import { Box, BoxProps } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const StyledBox = styled(Box)<BoxProps>`
  animation: ${fadeIn} 0.3s ease-in-out 1 forwards;
  will-change: opacity;
`;
